<section class="ref-view">
    <div class="ref-kpis">
        <div class="ref-kpi" *ngFor="let k of kpis"><span>{{k.label}}</span><b>{{k.value}}</b><small>{{k.sub}}</small></div>
    </div>

    <div class="ref-panel">
        <div class="ref-panel-h">
            <div>
                <h2>Payouts</h2>
                <p>Referrers redeem their EM Points balance for cash. Approve, move to processing, then mark as paid with the transaction reference.</p>
            </div>
            <div class="ref-tools">
                <select class="ref-inp" aria-label="Filter by payout status" [(ngModel)]="status" (ngModelChange)="onFilter()">
                    <option value="REQUESTED,UNDER_REVIEW">Pending approval</option>
                    <option value="APPROVED,PROCESSING">Approved, not paid</option>
                    <option value="PAID">Paid</option>
                    <option value="REJECTED,FAILED,CANCELLED">Rejected / failed</option>
                    <option value="">All</option>
                </select>
                <button class="btn btn-outline-primary" type="button" (click)="exportForBank()">
                    <i class="fas fa-download mr-50"></i>Export for bank transfer
                </button>
            </div>
        </div>

        <div class="ref-tbl-wrap">
            <table>
                <thead>
                <tr>
                    <th>Partner</th><th>Reference</th><th>Points</th><th>Amount</th><th>Pay to</th><th>Status</th><th>Requested</th><th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let p of pageRows">
                    <td><b>{{p.referrerName}}</b><small>{{p.referrerCode}}</small></td>
                    <td>{{p.reference}}</td>
                    <td>{{p.points}}</td>
                    <td class="ref-money">{{referralService.inr(p.amount)}}</td>
                    <td>{{p.destination}}<small>{{p.bankName}}</small></td>
                    <td><span class="ref-pill p-{{STATUS_CLASS[p.status]}}">{{STATUS_LABEL[p.status]}}</span></td>
                    <td>{{fmt(p.requestedAt)}}</td>
                    <td [ngSwitch]="p.status">
                        <span class="ref-tools" *ngSwitchCase="'REQUESTED'">
                            <button class="btn btn-primary btn-sm" type="button" (click)="approve(p)">Approve</button>
                            <button class="btn btn-outline-danger btn-sm" type="button" (click)="reject(p)">Reject</button>
                        </span>
                        <span class="ref-tools" *ngSwitchCase="'UNDER_REVIEW'">
                            <button class="btn btn-primary btn-sm" type="button" (click)="approve(p)">Approve</button>
                            <button class="btn btn-outline-danger btn-sm" type="button" (click)="reject(p)">Reject</button>
                        </span>
                        <span class="ref-tools" *ngSwitchCase="'APPROVED'">
                            <button class="btn btn-success btn-sm" type="button" (click)="process(p)">Process</button>
                            <button class="btn btn-outline-danger btn-sm" type="button" (click)="reject(p)">Reject</button>
                        </span>
                        <span class="ref-tools" *ngSwitchCase="'PROCESSING'">
                            <button class="btn btn-success btn-sm" type="button" (click)="markPaid(p)">Mark as paid</button>
                            <button class="btn btn-outline-danger btn-sm" type="button" (click)="markFailed(p)">Mark failed</button>
                        </span>
                        <small *ngSwitchCase="'PAID'">{{p.transactionReference}}</small>
                        <small class="ref-red" *ngSwitchCase="'REJECTED'">{{p.rejectionReason}}</small>
                        <small class="ref-red" *ngSwitchCase="'FAILED'">{{p.failureReason}}</small>
                    </td>
                </tr>
                <tr *ngIf="!loading && !pageRows.length"><td colspan="8" class="ref-empty">No payouts in this list.</td></tr>
                <tr *ngIf="loading"><td colspan="8" class="ref-empty">Loading…</td></tr>
                </tbody>
            </table>
        </div>
        <app-ref-pager [total]="total" [page]="page" [per]="per" (pageChange)="setPage($event)"></app-ref-pager>
    </div>
</section>
